import { move } from "formik";
import _ from "lodash";
import { useState, useEffect } from "react";
import {FiChevronDown,FiChevronUp,FiChevronRight,FiChevronLeft} from "react-icons/fi";


const SwapBox = ({ input, statedSelected, apply }) => {
    const [leftState, setLeft] = useState([]);
    const [rightState, setRight] = useState([]);

    const [selectedL, setSelectedL] = useState([]);
    const [selectedR, setSelectedR] = useState([]);


    function Move(direction){
        switch(direction){
            case "right":
                setRight(prev => [...prev, ...selectedL]);
                setLeft(prev => prev.filter(item => !selectedL.includes(item)));
                setSelectedL([]);
                break;
            case "left":
                setLeft(prev => [...prev, ...selectedR]);
                setRight(prev => prev.filter(item => !selectedR.includes(item)));
                setSelectedR([]);
                break;

            case "up":
                setRight(prev => {
                    const newRight = [...prev];
                    selectedR.forEach(item => {
                        const index = newRight.indexOf(item);
                        if (index > 0) {
                            [newRight[index - 1], newRight[index]] = [newRight[index], newRight[index - 1]];
                        }
                    });
                    return newRight;
                });
                break;

            case "down":
                setRight(prev => {
                    const newRight = [...prev];
                    selectedR.forEach(item => {
                        const index = newRight.indexOf(item);
                        if (index < newRight.length - 1) {
                            [newRight[index + 1], newRight[index]] = [newRight[index], newRight[index + 1]];
                        }
                    });
                    return newRight;
                });
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const source = Array.isArray(input) ? input : [];
        const normalizedSelected = Array.isArray(statedSelected) ? statedSelected : [];
        const selectedSet = new Set(normalizedSelected);

        const initialRight = source.filter(item => selectedSet.has(item));
        const initialLeft = source.filter(item => !selectedSet.has(item));

        setLeft(initialLeft);
        setRight(initialRight);
    }, [input, statedSelected]);


    return(
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "20px", padding: "20px"}}>
            <div>
                <span style={{fontSize: "13pt", fontWeight: "bold"}}>Available criteria</span>
                <div style={{border: "1px solid black", width: "350px", height: "230px", overflowY: "scroll"}}>
                    {leftState.map(item => (
                        <div key={item} onClick={() => setSelectedL(prev => prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item])} style={{padding: "5px", backgroundColor: selectedL.includes(item) ? "lightblue" : "white"}}>
                            {item}
                        </div>
                    ))}
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "10px", width: "30px", alignItems: "center", marginTop: "30px"}}>
                <div>
                    <FiChevronRight style={{fontSize: "30pt"}} onClick={e => Move("right")}></FiChevronRight>
                </div>
                <div>
                    <FiChevronLeft style={{fontSize: "30pt"}} onClick={e => Move("left")}></FiChevronLeft>
                </div>
                <div>
                    <FiChevronUp style={{fontSize: "30pt"}} onClick={e => Move("up")}></FiChevronUp>
                </div>
                <div>
                    <FiChevronDown  style={{fontSize: "30pt"}} onClick={e => Move("down")}></FiChevronDown>
                </div>
            </div>

            <div>
                <span style={{fontSize: "13pt", fontWeight: "bold"}}>Selected</span>
                <div style={{border: "1px solid black", width: "350px", height: "230px", overflowY: "scroll"}}>
                    {rightState.map(item => (
                        <div key={item} onClick={() => setSelectedR(prev => prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item])} style={{padding: "5px", backgroundColor: selectedR.includes(item) ? "lightblue" : "white"}}>
                            {item}
                        </div>
                    ))}
                </div>

            </div>

        </div>
    );




}

export default SwapBox;